var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22.75C10.2037 22.7395 9.91674 22.6429 9.6743 22.4721C7.27177 20.9272 5.16172 18.9691 3.4418 16.6885C1.8504 14.6683 0.970134 12.1793 0.937546 9.60776C0.937141 8.37197 1.18601 7.14879 1.66926 6.01141C2.15252 4.87403 2.86022 3.8458 3.75005 2.98826C5.55077 1.22575 7.97246 0.242204 10.4922 0.250006C13.0013 0.224789 15.418 1.19582 17.2122 2.95011C19.0063 4.70439 20.0314 7.09868 20.0625 9.60776C20.0282 12.1798 19.1464 14.6686 17.5538 16.6885C15.8265 18.9628 13.7173 20.9198 11.3202 22.4721C11.0805 22.6442 10.795 22.741 10.5 22.75ZM10.4922 6.74913C9.65674 6.74913 8.85552 7.08101 8.26478 7.67174C7.67405 8.26248 7.34217 9.0637 7.34217 9.89913C7.34066 10.3088 7.42166 10.7145 7.58035 11.0922C7.73903 11.4699 7.97215 11.8117 8.2658 12.0974C8.70862 12.5279 9.26736 12.82 9.87363 12.9378C10.4799 13.0557 11.1074 12.9942 11.6792 12.7609C12.2511 12.5276 12.7425 12.1327 13.0934 11.6244C13.4442 11.1161 13.6392 10.5166 13.6545 9.89913C13.6474 9.06336 13.3113 8.26406 12.7189 7.67443C12.1266 7.08481 11.3257 6.75236 10.4899 6.74913H10.4922Z",
    fill: "#0D0F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.e3f9e8e6971f024a9639b358002dd6d1.svg";
export { ForwardRef as ReactComponent };